import React, { useEffect } from 'react';
import { Container, Button, Typography} from '@mui/material';
import Header from '../components/layout/Header';
import { useParams } from 'react-router-dom';
import SoutienForm from '../components/forms/SoutienForm';

export const SoutienContext = React.createContext();
const SoutienProjet = () => {
    const { id } = useParams()
    const [load, setLoad] = React.useState(true);
    const [event, setEvent] = React.useState('');
    const [checkoutId, setCheckoutId] = React.useState(null);

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/public/project/${id}`, { method: 'GET' })
        .then(response => response.json())
        .then(data => {
            setEvent(data);
            setLoad(false);
        })
        .catch(error => console.error('Error fetching event:', error));
    }, [id]);
  
  return (
    <>
        <Header />
        <SoutienContext.Provider value={{setCheckoutId}}>
            <Container maxWidth="sm" sx={{ mt: 4, minWidth:'500px', display:'flex', flexDirection:'column' }}>
                <Typography variant='h2'>Je soutiens le projet<br/>{event?.titre}</Typography>
                <Typography variant="body1" gutterBottom>Promus par {event.organisateur}</Typography>
                <SoutienForm />
                <Button variant="contained" color="primary" size="large" sx={{alignSelf:'center', px:5, mb:2}}>Ajouter au panier</Button>
            </Container>
        </SoutienContext.Provider>
    </>
  );
};

export default SoutienProjet;